import AccountSearch from 'src/pages/Member/All'
import React from 'react'
import Paper from '@material-ui/core/Paper'
import Box from '@material-ui/core/Box'

export default function Step1(props) {
  return (
    <Box component={Paper} p={3} mb={4} elevation={0}>
      <AccountSearch {...props} />
    </Box>
  )
}
